export const PHONE_NUMBER = '0999 228 5498';
export const LOCATION_ADD = 'Quilaton Law Office, The Office, 2nd Floor, JY Square Mall, Lahug, Cebu City, Cebu, Philippines 6000';
export const EMAIL_ADD = 'appointment@quilatonlawoffice.com';
export const PHONE = "+639992285498";
export const PROXY = "https://www.quilatonlawoffice.com";
export const OFFICE_HOURS = 'Mon - Fri 09 AM - 06 PM';